import React, { SVGProps } from 'react';

export const NextStepsSVG = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.25 3.74805H23.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.25 12.748H23.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.25 21.748H23.25'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.799805 18.36C0.872215 18.0896 1.01885 17.8449 1.22312 17.6535C1.42739 17.4621 1.68115 17.3316 1.95569 17.277C2.23023 17.2223 2.51459 17.2455 2.77662 17.344C3.03865 17.4425 3.26788 17.6124 3.43839 17.8344C3.6089 18.0564 3.71388 18.3217 3.74146 18.6003C3.76904 18.8789 3.71811 19.1596 3.59444 19.4107C3.47077 19.6619 3.27929 19.8734 3.04166 20.0213C2.80403 20.1693 2.52974 20.2478 2.2498 20.248C2.52928 20.2479 2.80324 20.3259 3.04079 20.4731C3.27833 20.6204 3.47001 20.8311 3.59422 21.0814C3.71842 21.3318 3.77021 21.6119 3.74375 21.8901C3.71728 22.1683 3.61361 22.4336 3.44443 22.6561C3.27525 22.8785 3.04728 23.0493 2.78623 23.1491C2.52519 23.2489 2.24144 23.2738 1.967 23.221C1.69256 23.1682 1.43833 23.0398 1.23298 22.8502C1.02763 22.6606 0.879333 22.4174 0.804805 22.148'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.75 11.248C0.75 10.8502 0.908035 10.4687 1.18934 10.1874C1.47064 9.90608 1.85218 9.74805 2.25 9.74805V9.74805C2.64782 9.74805 3.02936 9.90608 3.31066 10.1874C3.59196 10.4687 3.75 10.8502 3.75 11.248C3.75015 11.7336 3.58511 12.2047 3.282 12.584L0.75 14.248H3.75'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.75 0.748047H1.5C1.69891 0.748047 1.88968 0.827064 2.03033 0.967717C2.17098 1.10837 2.25 1.29913 2.25 1.49805V6.74805'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.75 6.74805H3.75'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
